export const article = [
  {
    articleId: 14,
    url: "dispositivos-compatibles-con-mega-go",
    category: {
      slug: "comenzar",
      name: "Comenzar",
    },
    title: "Dispositivos compatibles con Mega GO",
    content: (
      <>
        <div className="row">
          <p>
            Explora la biblioteca de Mega GO en cualquier dispositivo
            compatible.
          </p>
        </div>
        <div className="row">
          <h2>Navegadores web</h2>
          <div className="accordeonContent">
            <ul className="decimal">
              <li>Chrome</li>
            </ul>
          </div>
        </div>
        <div className="row">
          <h2>Dispositivos móviles y tabletas</h2>
          <div className="accordeonContent">
            <ul className="decimal">
              <li>
                Teléfonos Android (Android 9.0 o posterior)
                <ul className="disc subList">
                  <li>Abre la app "Ajustes y/o configuración".</li>
                  <li>Ve a "Sistema".</li>
                  <li>
                    En el buscador que aparecerá en la parte superior, escribe
                    "Versión de Android". Pulsa sobre el acceso que aparecerá en
                    los resultados de búsqueda.
                  </li>
                  <li>
                    Luego, en tu celular se mostrará la versión de Android que
                    tienes instalada, donde podrás ver como "Android 12.0",
                    "Android 13.0", etc.
                  </li>
                </ul>
              </li>
              <li>
                Teléfonos iOS (iOS 15.0 o posterior)
                <ul className="disc subList">
                  <li>En un iPhone o iPad:
                    <ul className="disc subList">
                      <li>Para identificar qué versión de software tienes instalada en el dispositivo, ve a Configuración &gt; General y toca Información.</li>
                      <li>En esta pantalla, se mostrará la versión de software del dispositivo.</li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="row">
          <h2>Dispositivos de streaming</h2>
          <div className="accordeonContent">
            <ul className="decimal">
              <li>Chromecast</li>
              <li>Roku</li>
            </ul>
          </div>
        </div>
        <div className="">
          <h2>Televisores inteligentes</h2>
          <div className="accordeonContent">
            <ul className="decimal">
              <li>
                TV LG (WebOS 5.0 o posterior)
                <ul className="disc subList">
                  <li>Abre el store de tu TV.</li>
                  <li>En el buscador que te aparecerá, escribe “Mega GO”.</li>
                  <li>Aprieta sobre descargar.</li>
                  <li>Coloca las credenciales (usuario y contraseña). Para comenzar a disfrutar del contenido.</li>
                  <span>Si tienes dudas sobre si el modelo de tu TV es compatible, puedes revisarlo en el siguiente link: <a href="https://cl.lgappstv.com/main/appSearch" target="_blank" rel="noreferrer">https://cl.lgappstv.com/main/appSearch </a></span>
                </ul>
              </li>
              <li>
                TV Samsung (Modelos 2022-2026)
                <ul className="disc subList">
                  <li>Abre el store de tu TV.</li>
                  <li>En el buscador que te aparecerá, escribe “Mega GO”.</li>
                  <li>Aprieta sobre descargar.</li>
                  <li>Coloca las credenciales (usuario y contraseña). Para comenzar a disfrutar del contenido.</li>
                  <div>Si tienes dudas sobre si el modelo de tu TV es compatible, puedes revisarlo en el siguiente link: <a href="https://developer.samsung.com/smarttv/develop/specifications/tv-model-groups.html" target="_blank" rel="noreferrer">https://developer.samsung.com/smarttv/develop/specifications/tv-model-groups.html</a></div>
                </ul>
              </li>
              <li>
                TV Hisense (con sistema VIDAA)
                <ul className="disc subList">
                  <li>Ingresa al menú lateral de "Buscar".</li>
                  <li>En el buscador que te aparecerá, escribe “Mega GO”.</li>
                  <li>Busca en Apps y descarga la aplicación.</li>
                  <li>Coloca las credenciales (usuario y contraseña). Para comenzar a disfrutar del contenido.</li>
                </ul>
              </li>
              <li>
                TV Android
                <ul className="disc subList">
                  <li>Abre el store de tu TV.</li>
                  <li>En el buscador que te aparecerá, escribe “Mega GO TV”.</li>
                  <li>Aprieta sobre descargar.</li>
                  <li>Coloca las credenciales (usuario y contraseña). Para comenzar a disfrutar del contenido.</li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </>
    ),
  },
];
